import React from "react";
import { ChevronLeft } from "lucide-react";
import { Link } from "react-router-dom";
import heroImage from "@/assets/images/landing/hero/classroom-hero.jpg";

const ApplicationHero: React.FC = () => {
    return (
        <section className="relative h-[300px] flex flex-col items-center justify-center text-center text-white">
            
            {/* Background */}
            <img
                src={heroImage}
                alt="Application Background"
                className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black/60"></div>

            {/* Content */}
            <div className="relative z-10 w-full">
                {/* Breadcrumb Navigation */}
                <div className="flex items-center justify-start text-sm px-6 md:px-16 pt-4">
                    <ChevronLeft size={16} className="mr-1 opacity-80" />
                    <Link
                        to="/"
                        className="text-gray-200 hover:text-white hover:underline transition-colors"
                    >
                        Home
                    </Link>
                    <span className="mx-1">/</span>
                    <span className="text-white">Complete Application</span>
                </div>
                <div className="flex flex-col items-center justify-center px-6">
                    {/* Heading + Description */}
                    <h1 className="text-4xl md:text-5xl font-semibold mb-4 mt-12">
                        Complete Your Application
                    </h1>
                    <p className="text-[#B8B8B8] text-base leading-relaxed max-w-3xl mx-auto">
                        Begin a transformative learning experience that will equip you with the
                        skills and knowledge to thrive in your career. We are committed to your
                        success and will support you every step of the way.
                    </p>
                </div>
                
            </div>
        </section>
    );
};

export default ApplicationHero;
